import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SimpleBarReact from 'simplebar-react';
import { Card, ListGroup, ListGroupItem, ToggleButton } from 'react-bootstrap';
import ArticleDetailsMedia from './ArticleDetailsMedia';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SoftBadge from 'components/common/SoftBadge';
import { Link } from 'react-router-dom';
import { setItemToStore } from 'helpers/utils';

const ArticleCard = ({ article }) => {
 const [radioValue, setRadioValue] = useState({});
 const [makeover, setMakeover] = useState(null);
 const [imagesArticle, setImagesArticle] = useState([]);
 const { code, images, name, manufacturer, identification, summary, references, measuring, quantities, specifications } = article;

 const onChange = ({ target: { name, value } }) => {
  setMakeover(`${name}-${value}`);
  setRadioValue({ ...radioValue, [name]: value });
 };

 useEffect(() => {
  if (makeover) {
   const [ref, name] = makeover.split('-');
   const imgs = references.find(e => e.reference === ref)?.properties.find(e => e.name === name)?.images ?? [];
   if (imgs.length) setImagesArticle(imgs);
  }
 }, [makeover]);

 useEffect(() => {
  setImagesArticle(images);
 }, [article]);

 return (
  <Card>
   <ArticleDetailsMedia article={{ files: imagesArticle, isNew: true }} style={{ height: '200px' }} />
   <Card.Body className="pb-1">
    <Card.Title>{name}</Card.Title>
    <p className="fs--2 fs-md--1 text-end text-md-start mb-0">{`Creado por ${manufacturer} - id ${identification}`}</p>
   </Card.Body>

   <ListGroup className="list-group-flush">
    {references.map((e, i) => (
     <ListGroupItem className="pb-0" key={i} action>
      <small className="text-muted float-end">{e.reference.toLowerCase()}</small>
      <br />
      <SimpleBarReact className="m-0" forceVisible="x" autoHide={true} style={{ whiteSpace: 'nowrap', overflowX: 'auto' }}>
       <Flex className="mb-3 mx-1 mt-1">
        {e.properties.map((prop, i) => (
         <ToggleButton
          key={i}
          size="sm"
          type="radio"
          className="me-1"
          value={prop.name}
          name={e.reference}
          onChange={onChange}
          variant="falcon-default"
          id={`${e.reference}-${i}`}
          checked={radioValue[e.reference] === prop.name}
         >
          <Flex alignItems="center" wrap="nowrap" justifyContent="center">
           {prop.color ? (
            <FontAwesomeIcon icon="circle" className="" transform="shrink-3" style={{ color: prop.color }} />
           ) : (
            <></>
           )}
           <span className="">{prop.name.toLowerCase()}</span>
          </Flex>
         </ToggleButton>
        ))}
       </Flex>
      </SimpleBarReact>
     </ListGroupItem>
    ))}

    <ListGroupItem>
     <Flex alignItems="center" wrap="nowrap" justifyContent="between">
      <span>Unidad de medida</span>
      <SoftBadge pill bg="secondary">
       {measuring}
      </SoftBadge>
     </Flex>
    </ListGroupItem>
    <ListGroupItem>
     <Flex alignItems="center" wrap="nowrap" justifyContent="between">
      <span>Cantidades</span>
      <span>[{quantities.join('-')}]</span>
     </Flex>
    </ListGroupItem>

    <Card.Body>
     <Card.Text>{summary}</Card.Text>
     <Flex direction="row" className="mb-3">
      {specifications.map((e, i) => (
       <small key={i} className="col-6">
        <FontAwesomeIcon icon="circle" className="me-1" transform="shrink-3" />
        {e.label}: {e.property}
       </small>
      ))}
     </Flex>
     <Card.Link href="#">Card Link</Card.Link>
     <Card.Link as={Link} to={'edit/' + code} onClick={() => setItemToStore('article', article)}>
      Editar
     </Card.Link>
    </Card.Body>
   </ListGroup>
  </Card>
 );
};

ArticleCard.propTypes = {
 article: PropTypes.shape({
  _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  code: PropTypes.string.isRequired,
  quantities: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  manufacturer: PropTypes.string.isRequired,
  measuring: PropTypes.string.isRequired,
  identification: PropTypes.string,
  summary: PropTypes.string,
  images: PropTypes.array,
  taxes: PropTypes.array,
  params: PropTypes.object,
  references_name: PropTypes.array,
  references: PropTypes.arrayOf(
   PropTypes.shape({
    reference: PropTypes.string.isRequired,
    properties: PropTypes.arrayOf(
     PropTypes.shape({ name: PropTypes.string.isRequired, color: PropTypes.string, images: PropTypes.array })
    ).isRequired
   })
  ),
  specifications: PropTypes.arrayOf(
   PropTypes.shape({ label: PropTypes.string.isRequired, property: PropTypes.string.isRequired })
  )
 }).isRequired
};

export default ArticleCard;
